import React from 'react'
import { Route } from 'react-router-dom'
import AuthorizedComponent from 'src/components/Auth/AuthorizedComponent'
import Sspsa from 'src/modules/Sspsa'

const route = <Route path="/sspsa" element={<AuthorizedComponent component={Sspsa} />} />

export default route
